module.exports = __webpack_public_path__ + "static/media/Orch_OneStep_Webpages_Logos_NoText-07.1f231e23.png";